import React from 'react';
import TimeAgo from 'react-timeago';

function timestampFormatter(value, unit, suffix, date) {

    return `${value}${unit.charAt(0)}`;
}

function Timestamp({ value }) {

    return (
        <TimeAgo date={Number(value)} minPeriod={15} formatter={timestampFormatter} />
    );
}

export default Timestamp;


// WEBPACK FOOTER //
// ./src/components/Timestamp.jsx